<div class="story-run-params-container">
  <div class="loading" *ngIf="loading">
    {{ 'story-run-params.message.loading' | translate }}
  </div>

  <div class="empty" *ngIf="!loading && notFound">
    {{ 'story-run-params.message.not-found' | translate }}
  </div>

  <ng-container *ngIf="!loading && storyParams">
    <section class="params-section" *ngIf="paramItems.length > 0">
      <h5 class="params-heading">
        {{ 'story-run-params.heading.main' | translate }}
      </h5>
      <dl class="params-list">
        <ng-container *ngFor="let item of paramItems">
          <dt class="param-label">{{ item.label }}</dt>
          <dd class="param-value">{{ formatValue(item.value) }}</dd>
        </ng-container>
      </dl>
    </section>

    <section class="params-section" *ngIf="promptParamItems.length > 0">
      <h5 class="params-heading">
        {{ 'story-run-params.heading.prompt-params' | translate }}
      </h5>
      <dl class="params-list">
        <ng-container *ngFor="let item of promptParamItems">
          <dt class="param-label">{{ item.label }}</dt>
          <dd class="param-value">{{ formatValue(item.value) }}</dd>
        </ng-container>
      </dl>
    </section>
  </ng-container>
</div>
